import { Injectable } from '@angular/core';
import { SiteService, SscClientService, SscRequest } from '@sla-ng/core';
import { map, Observable, of, tap } from 'rxjs';
import { IGlobalConfig } from '../models/global-config.model';
import { MenuItem } from '../models/menu-item.model';

/**
 * The `SlaSidenavService` is a service that provides methods to retrieve
 * shared menu items from an external configuration file. It relies on an HTTP client
 * to fetch the configuration file and utilizes a `SiteService` to determine the path
 * to this configuration.
 */
@Injectable({
    providedIn: 'root',
})
export class GlobalConfigService {

    private loadedConfig: IGlobalConfig = {};

    constructor(
        private mySiteService: SiteService,
        private mySscClientService: SscClientService
    ) { }

    public getLoadedConfig(): IGlobalConfig {
        return this.loadedConfig;
    }


    public getSharedMenuItems(): MenuItem[] {
        return this.loadedConfig?.menuItems;
    }


    public loadGlobalConfig(): Observable<IGlobalConfig> {
        const appConfigPath: string = this.mySiteService.getConfigKey('app-config-path');
        if (!appConfigPath) {
            return of({});
        }
        const sscRequest: SscRequest = new SscRequest();
        sscRequest.aModule = 'appstore';
        sscRequest.aFunction = 'loadconfig';
        sscRequest.aData = { filename: appConfigPath };
        // reuse and share observable to prevent multiple requests
        return this.mySscClientService.call(sscRequest, null, false).pipe(
            map(res => {
                if (res?.sscresponse?.data?.content){
                    return JSON.parse(atob(res.sscresponse.data.content));
                }
                return {};
            }),
            tap((val: IGlobalConfig) => {
                this.loadedConfig = val;
                GlobalConfigService.getGlobalConfig = (): IGlobalConfig => {
                    return val || {};
                };
            }),
        );
    }


    public static getGlobalConfig(): IGlobalConfig {
        return {};
    }
}
